import { digitsMask } from '@/utils/forms/inputMasks'

import { labelWithTooltip } from '../../RequiredLabel/labelWithTooltip'
import {
  ConfigCheckboxField,
  type ConfigFieldContext,
  ConfigTextField,
} from '../ConfigFields/ConfigFields'
import cn from '../ConfigModal.module.scss'
import type { ConfigFileFormat, ConfigSourceType } from '../lib/configFormModel'
import { CONFIG_TOOLTIPS } from '../lib/configModalTexts'
import { getFileMaskPlaceholder } from '../lib/configRequest'

type ConfigConnectionFieldsProps = {
  context: ConfigFieldContext
  sourceType: ConfigSourceType
  fileFormat: ConfigFileFormat
  onFileMaskBlur: () => void
}

function ConfigConnectionFields({
  context,
  sourceType,
  fileFormat,
  onFileMaskBlur,
}: ConfigConnectionFieldsProps) {
  const isMail = sourceType === 'EMAIL' || sourceType === 'CUSTOM_IMAP'

  return (
    <div className={cn.grid}>
      {sourceType === 'URL' && (
        <div className={cn.wide}>
          <ConfigTextField
            context={context}
            name="url"
            title={labelWithTooltip('Публичная ссылка', CONFIG_TOOLTIPS.url)}
            required
            placeholder="https://"
          />
        </div>
      )}
      {isMail && (
        <>
          <ConfigTextField
            context={context}
            name="expectedSender"
            title={labelWithTooltip(
              'Допустимый отправитель',
              CONFIG_TOOLTIPS.expectedSender
            )}
            required={sourceType === 'EMAIL'}
            placeholder="manager@pips.by"
          />
          <ConfigTextField
            context={context}
            name="subjectMask"
            title={labelWithTooltip(
              'Маркер темы письма',
              CONFIG_TOOLTIPS.subjectMask
            )}
            required={sourceType === 'EMAIL'}
            placeholder="Остатки Альфа"
          />
          <ConfigTextField
            context={context}
            name="fileMask"
            title={labelWithTooltip(
              'Имя или маска файла',
              CONFIG_TOOLTIPS.fileMask
            )}
            required
            placeholder={
              fileFormat ? getFileMaskPlaceholder(fileFormat) : undefined
            }
            onBlur={onFileMaskBlur}
          />
        </>
      )}
      {sourceType === 'CUSTOM_IMAP' && (
        <>
          <ConfigTextField
            context={context}
            name="imapHost"
            title="IMAP-сервер"
            placeholder="Можно оставить пустым"
          />
          <ConfigTextField
            context={context}
            name="imapPort"
            title="IMAP-порт"
            placeholder="993"
            mask={digitsMask}
          />
          <ConfigTextField
            context={context}
            name="imapLogin"
            title="Логин"
            required
          />
          <ConfigTextField
            context={context}
            name="imapPasswordEncrypted"
            title="Пароль / пароль приложения"
            required
            secret
            autoComplete="new-password"
          />
          <div className={cn.checkboxCell}>
            <ConfigCheckboxField context={context} name="useSsl">
              SSL
            </ConfigCheckboxField>
          </div>
        </>
      )}
    </div>
  )
}

export default ConfigConnectionFields
